module.exports = __webpack_public_path__ + "static/media/classic-click-setup.75015052.gif";